"use strict";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var mitt = require('mitt');

var wait = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var ms,
        _args = arguments;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            ms = _args.length > 0 && _args[0] !== undefined ? _args[0] : 0;
            return _context.abrupt("return", new Promise(function (resolve) {
              return setTimeout(resolve, ms);
            }));

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function wait() {
    return _ref.apply(this, arguments);
  };
}();

var chain = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(promisesFns) {
    var r, i, v;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            r = [];
            i = 0;

          case 2:
            if (!(i < promisesFns.length)) {
              _context2.next = 10;
              break;
            }

            _context2.next = 5;
            return promisesFns[i]();

          case 5:
            v = _context2.sent;
            r.push(v);

          case 7:
            i++;
            _context2.next = 2;
            break;

          case 10:
            return _context2.abrupt("return", r);

          case 11:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function chain(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var throttledParallelTasks = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(tasks, options) {
    var _ref4, _ref4$batchSize, batchSize, _ref4$batchDelay, batchDelay, onStepComplete, onBatchComplete, results, i, batchResults;

    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _ref4 = options || {}, _ref4$batchSize = _ref4.batchSize, batchSize = _ref4$batchSize === void 0 ? 1 : _ref4$batchSize, _ref4$batchDelay = _ref4.batchDelay, batchDelay = _ref4$batchDelay === void 0 ? 0 : _ref4$batchDelay, onStepComplete = _ref4.onStepComplete, onBatchComplete = _ref4.onBatchComplete;
            results = [];
            batchSize = parseInt(batchSize);

            if (!(isNaN(batchSize) || batchSize < 1)) {
              _context4.next = 5;
              break;
            }

            throw new Error('batchSize must be a positive integer');

          case 5:
            i = 0;

          case 6:
            if (!(i < tasks.length)) {
              _context4.next = 18;
              break;
            }

            if (!i) {
              _context4.next = 10;
              break;
            }

            _context4.next = 10;
            return wait(batchDelay);

          case 10:
            _context4.next = 12;
            return Promise.all(tasks.slice(i, i + batchSize).map( /*#__PURE__*/function () {
              var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(task) {
                var result;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        _context3.next = 2;
                        return task();

                      case 2:
                        result = _context3.sent;

                        if (typeof onStepComplete === 'function') {
                          onStepComplete(result);
                        }

                        return _context3.abrupt("return", result);

                      case 5:
                      case "end":
                        return _context3.stop();
                    }
                  }
                }, _callee3);
              }));

              return function (_x4) {
                return _ref5.apply(this, arguments);
              };
            }()));

          case 12:
            batchResults = _context4.sent;
            results.push(batchResults);

            if (typeof onBatchComplete === 'function') {
              onBatchComplete(batchResults);
            }

            i += batchSize;
            _context4.next = 6;
            break;

          case 18:
            return _context4.abrupt("return", results);

          case 19:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function throttledParallelTasks(_x2, _x3) {
    return _ref3.apply(this, arguments);
  };
}(); // AN OBJECT TO KEEP TRACK OF ALL QUEUES IN MEMORY


var QUEUES = {};

function createAsyncQueue(_ref6) {
  var _ref6$namespace = _ref6.namespace,
      namespace = _ref6$namespace === void 0 ? "global" : _ref6$namespace,
      _ref6$MAX_NUM_PARALLE = _ref6.MAX_NUM_PARALLEL_TASKS,
      MAX_NUM_PARALLEL_TASKS = _ref6$MAX_NUM_PARALLE === void 0 ? 200 : _ref6$MAX_NUM_PARALLE;

  if (mitt && typeof mitt !== 'function') {
    mitt = mitt.default;
  }

  var eventEmitter = mitt();
  var tasks = [];

  function evaluate() {
    // remove non-function members which may have been passed in by mistake
    tasks = tasks.filter(function (t) {
      return typeof t === 'function';
    });
    tasks.filter(function (t, i) {
      return !t._pending && i < MAX_NUM_PARALLEL_TASKS;
    }).forEach( /*#__PURE__*/function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(t) {
        var result, finish;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                finish = function _finish() {
                  eventEmitter.emit('taskFinished', {
                    t: t,
                    result: result
                  });
                };

                t._pending = true;
                ;
                _context5.prev = 3;
                _context5.next = 6;
                return t();

              case 6:
                result = _context5.sent;
                _context5.next = 13;
                break;

              case 9:
                _context5.prev = 9;
                _context5.t0 = _context5["catch"](3);
                finish();
                throw _context5.t0;

              case 13:
                finish();

              case 14:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, null, [[3, 9]]);
      }));

      return function (_x5) {
        return _ref7.apply(this, arguments);
      };
    }()); // for backwards compatibility, also save tasks to the `requests` key

    eventEmitter.tasks = eventEmitter.requests = tasks;

    if (!tasks.length && !eventEmitter._completed) {
      eventEmitter._completed = true;
      eventEmitter.emit('completed');
    } else if (tasks.length) {
      eventEmitter._completed = false;
    }
  } // add one or more tasks


  eventEmitter.on('add', function (t) {
    // coerce to array
    if (!Array.isArray(t)) {
      t = [t];
    }

    tasks = tasks.concat(t);
  });
  eventEmitter.on('prepend', function (t) {
    return tasks.unshift(t);
  });
  eventEmitter.on('insert', function (_ref8) {
    var t = _ref8.t,
        _ref8$i = _ref8.i,
        i = _ref8$i === void 0 ? tasks.length - 1 : _ref8$i;
    return tasks.splice(i, 0, t);
  });
  eventEmitter.on('taskFinished', function (_ref9) {
    var t = _ref9.t;
    return tasks = tasks.filter(function (_t) {
      return _t !== t;
    });
  });
  eventEmitter.on('clear', function () {
    tasks.forEach(cancelTask);
    tasks = [];
  });

  function cancelTask(t) {
    if (typeof t.reject === 'function') {
      t.reject({
        cancelled: true
      });
      tasks = tasks.filter(function (_t) {
        return _t !== t;
      });
    }
  }

  eventEmitter.on('*', evaluate);
  QUEUES[namespace] = eventEmitter; // for backwards compatibility, also save tasks to the `requests` key

  eventEmitter.tasks = eventEmitter.requests = tasks;
  eventEmitter.cancelTask = cancelTask;
  return eventEmitter;
}

function getAsyncQueue(params) {
  var namespace = params.namespace;
  var existing = QUEUES[namespace];

  if (!existing) {
    var q = createAsyncQueue(params);
    return q;
  }

  return existing;
}

function clearAsyncQueues() {
  var _ref10 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      namespace = _ref10.namespace;

  var queuesToClear = namespace ? [QUEUES[namespace]] : Object.keys(QUEUES).map(function (k) {
    return QUEUES[k];
  });
  return queuesToClear.map(function (q) {
    q.emit('clear');
  });
}

module.exports = {
  wait: wait,
  chain: chain,
  throttledParallelTasks: throttledParallelTasks,
  createAsyncQueue: createAsyncQueue,
  getAsyncQueue: getAsyncQueue,
  clearAsyncQueues: clearAsyncQueues
};